import { OTPInput, type OTPInputProps, type SlotProps } from 'input-otp';
import { forwardRef } from 'react';
import { cn } from './cn';

export type InputOTPProps = Omit<OTPInputProps, 'render' | 'children' | 'maxLength'> & {
  maxLength?: number;
};

export const InputOTPSlot = ({ char, isActive }: SlotProps) => (
  <div
    className={cn(
      'flex h-14 w-12 items-center justify-center text-2xl font-bold transition-colors',
    )}
    style={{
      borderWidth: isActive ? '2px' : '1px',
      borderStyle: 'solid',
      borderColor: isActive ? 'var(--accent-default)' : 'var(--divider-strong)',
      background: 'var(--surface-0)',
      color: 'var(--content-strong)',
      fontFamily: "'Pretendard Variable', system-ui, sans-serif",
      letterSpacing: '-0.48px',
      fontVariantNumeric: 'tabular-nums',
    }}
    aria-hidden
  >
    {char}
  </div>
);

export const InputOTP = forwardRef<HTMLInputElement, InputOTPProps>(
  ({ maxLength = 6, ...props }, ref) => (
    <OTPInput
      ref={ref}
      maxLength={maxLength}
      inputMode="numeric"
      pattern="^[0-9]{0,6}$"
      containerClassName="flex justify-between gap-2"
      render={({ slots }) => (
        <>
          {slots.map((slot, idx) => (
            <InputOTPSlot key={idx} {...slot} />
          ))}
        </>
      )}
      {...props}
    />
  ),
);
InputOTP.displayName = 'InputOTP';

export type { SlotProps } from 'input-otp';
